import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=d3a86d12&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=d3a86d12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a86d12",
  null
  
)

export default component.exports